import React, { PureComponent } from 'react';
import Slider from 'react-slick';
import { Icon } from 'appSrc/components/UI';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    lazyLoad: 'progressive',
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint:840,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint:480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
    ],
};

class UnderslungCarousel extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            atBeginning: true,
            atEnd: false,
        };
    }
    componentDidMount() {
        if( this._slider ) {
            var atZero = true;
            var overLimit = this._slider.props.slidesToShow >= this._slider.props.children.length;
            if( atZero && overLimit ) {
                this.setState( { atBeginning: true, atEnd: true } );
            } else if( atZero ) {
                this.setState( { atBeginning: true, atEnd: false } );
            } else if( overLimit ) {
                this.setState( { atBeginning: false, atEnd: true } );
            } else {
                this.setState( { atBeginning: false, atEnd: false } );
            }
        }
    }
    slickNext = () => {
        this._slider && this._slider.slickNext();
    }
    slickPrev = () => {
        this._slider && this._slider.slickPrev();
    }
    beforeChange = ( oldIndex, newIndex ) => {
        var atZero = newIndex == 0;
        var overLimit = newIndex + this._slider.props.slidesToScroll >= this._slider.props.children.length;
        if( atZero && overLimit ) {
            this.setState( { atBeginning: true, atEnd: true } );
        } else if( atZero ) {
            this.setState( { atBeginning: true, atEnd: false } );
        } else if( overLimit ) {
            this.setState( { atBeginning: false, atEnd: true } );
        } else {
            this.setState( { atBeginning: false, atEnd: false } );
        }
    }
    render() {
        const options = {
            ...carouselOptions,
            ...this.props.carouselOptions,
            arrow: false,
        };

        return (
            <div className={ `${ style.underslungCarousel } ${ this.props.className }`.trim() }>
                <Slider { ...options } ref={ ( el ) => { this._slider = el; } }
                beforeChange={ this.beforeChange }>
                    { this.props.children }
                </Slider>
                <div className={ style.controls }>
                    <Icon source='customSvg' icon='carousel-prev' size={ 60 } onClick={ this.slickPrev }
                    disabled={ this.state.atBeginning } />
                    <Icon source='customSvg' icon='carousel-next' size={ 60 } onClick={ this.slickNext }
                    disabled={ this.state.atEnd } />
                </div>
            </div>
        );
    }
}
UnderslungCarousel.propTypes = {
    className: PropTypes.string,
    carouselOptions: PropTypes.object,
};
UnderslungCarousel.defaultProps = {
    className: '',
    carouselOptions: {},
};

export default UnderslungCarousel;
